<div class="c-object-lookup__content--wrapper">

  <app-bui-spinner
    *ngIf="showLoader"
    [spinnerType]="'content'"
    [spinnerSize]="'xs'"
    [spinnerHasOverlay]="false"
    class="c-object-lookup__content--wrapper-spinner">
  </app-bui-spinner>

  <mat-form-field class="u-mat-full" appearance="outline" color="accent" floatLabel="always"
    [hideRequiredMarker]="hideRequiredMarker">
    <mat-label [matTooltip]="label">
      <ng-container *ngIf="ngControl.control.hasValidator(Validators.required)">{{ label }}</ng-container>
      <ng-container *ngIf="!ngControl.control.hasValidator(Validators.required)">{{ label | optionalFieldTranslate }}
      </ng-container>
    </mat-label>
    <input
      type="text"
      matInput
      #autoCompleteInput="matAutocompleteTrigger"
      [matAutocomplete]="auto"
      [matTooltip]="filterFormControl?.value | recordDisplayValue: _object"
      [formControl]="filterFormControl"
      [ngClass]="[
        isFullWide ? 'u-mat-full' : ''
      ]"
      [placeholder]="'COMMON.START_SEARCHING' | translate"
      (focus)="onFocus($event)">
    <mat-icon matSuffix class="c-object-lookup__content-arrow"
      [ngClass]="[
        ngControl.disabled ? 'u-disabled' : ''
      ]"
      [svgIcon]="'svg:icon-arrow-down'">
    </mat-icon>
    <button
      matSuffix
      mat-icon-button
      type="button"
      [ngClass]="[
        ngControl.disabled ? 'u-disabled' : ''
      ]"
      (click)="openDialog($event)">
      <mat-icon *ngIf="(isBuiIconMaterialIconType | wrapFn: suffixType)"
        [svgIcon]="suffixType + ':' + suffix">
      </mat-icon>
    </button>
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="optionSelected($event)"
      autoActiveFirstOption="true">
      <ng-container *ngIf="!items?.length && filterFormControl.value">
        <mat-option
          [disabled]="true">
          {{ 'COMMON.NO_DATA' | translate }}
        </mat-option>
      </ng-container>
      <div class="c-object-lookup__content--options"
           [ngClass]="items?.length > 0 && items?.length !== pagination?.totalElements ? 'c-object-lookup__content--options__has-space' : ''">
        <ng-container *ngFor="let item of items">
          <mat-option
            [matTooltip]="item | recordDisplayValue: _object"
            [matTooltipPosition]="'below'"
            [value]="item"
            [disabled]="item.disabled">
            {{ item | recordDisplayValue: _object }}
          </mat-option>
        </ng-container>
      </div>
      <div>
        <div *ngIf="items?.length > 0 && items?.length !== pagination?.totalElements"
          class="u-flex u-flex-center"
          [ngClass]="items?.length > 0 && items?.length !== pagination?.totalElements ? 'c-object-lookup__content--load-more-button' : ''">
          <app-bui-load-more-button (click)="loadMore()">
            {{ 'COMMON.LOAD_MORE' | translate }}
          </app-bui-load-more-button>
        </div>
      </div>
    </mat-autocomplete>
    <mat-error *ngIf="filterFormControl.errors?.required">
      {{ 'VALIDATIONS.FIELD_REQUIRED' | translate }}
    </mat-error>
    <mat-error *ngIf="filterFormControl.errors?.uniqueField">
      {{ 'VALIDATIONS.UNIQUE_FIELD' | translate }}
    </mat-error>
  </mat-form-field>
</div>

<ng-container *ngIf="observeTouched()"></ng-container>
<ng-container *ngIf="observeDisabled()"></ng-container>
<ng-container *ngIf="observeErrors()"></ng-container>
